import React from 'react';
import { OrderBookRowFieldProps } from '../../../types';

export const OrderBookSideAlert = (props: OrderBookRowFieldProps) => {
  return null; // <i className="fa fa-bell fa-fw show50"></i>
};

export default OrderBookSideAlert;
